import Index from '../views/Index.vue'
import Duty from '../views/Duty.vue'
import Party from '../views/Party.vue'
import Policy from '../views/Policy.vue'
import Office from '../views/Office.vue'
import Media from '../views/Media.vue'
import ListPage from '../views/ListPage.vue'
import RightDetail from '../components/news/RightDetail.vue'
import NewsList from '../components/news/NewsList.vue'


//网站配置
const comData = {
  navList: [
    {
      id:1,
      title:'首页',
      path:'/index',
      name:"Index",
      alias:"index",
      component: () => import('@/views/Index.vue'),
      element:[{
        id:1,
        url:'',
        name:"工作动态",
        type:"Carousel",
        data:{
          "channelId":"homeChart",
          "showCount":4
        },
      },
      {
        id:2,
        data:{
          "channelId":"dynamicWork",
          "showCount":7
        },
        name:"工作动态",
        type:"Work"
      },
      {
        id:3,
        data:{
          "channelId":"announcements",
          "showCount":7
        },
        name:"通知公告",
        type:"Notice"
      },
      {
        id:4,
        data:{
          "channelId":"law",
          "showCount":7
        },
        name:"政策法规",
        type:"Notice"
      },
      {
        id:5,
        type:"ImgLink",
        data:{
          "channelId":"threePicture",
          "showCount":1
        },
        name:"界面三张图",
        isShow:true,
        img:[{path:require("@/assets/img/entrance-dj.png"),url:"/party"},
        {path:require("@/assets/img/entrance-bs.png"),url:"/office"},
        {path:require("@/assets/img/entrance-zw.png"),url:"http://zwfw.nmg.gov.cn/OrgItem_index?regionCode=150000&orgCode=TE1500000000000001&record=istrue"},
        {path:require("@/assets/img/entrance-dt.png"),url:"/exam"}]
      },
        {
          id:6,
          url:'',
          data:{
            "channelId":"confidentialSense",
            "showCount":7
          },
          name:"保密常识",
          type:"Notice"
        },
      {
        id:7,
        data:{
          "channelId":"confidentialityProtection",
          "showCount":7
        },
        name:"技术防护",
        type:"Notice"
      },

      {
        id:8,
        data:{
          "channelId":"ringing",
          "showCount":7
        },
        name:"警钟长鸣",
        type:"Notice"
      },
      {
        id:9,
        data:{
          "channelId":"video",
          "showCount":7
        },
        name:"视频点播",
        type:"Video"
      },
      {
        id:10,
        data:{
          "channelId":"carton",
          "showCount":7
        },
        name:"保密漫画",
        type:"Video"
      },
      {
        id:11,
        data:{
          "channelId":"journal",
          "showCount":7
        },
        name:"保密期刊",
        type:"Book"
      },
      {
        id:12,
        url:'',
        name:"相关链接",
        type:"Link",
        img:[{path:require("@/assets/img/link/gjbmj.png"),url:"http://www.gjbmj.gov.cn/"},
        {path:require("@/assets/img/link/bmkj.png"),url:"http://www.nsstec.org.cn/"},
        {path:require("@/assets/img/link/jccbs.png"),url:"http://jccb.com.cn/"},
        {path:require("@/assets/img/link/zgbmzx.png"),url:"http://www.baomi.org.cn/"},
        ],
        hoverImg:[{path:require("@/assets/img/link/bmg.png"),url:""},],
        other:[{name:"江苏省保密局",url:"http://www.jsbm.gov.cn/"},
        {name:"江西省保密局",url:"http://www.jxbm.gov.cn/"},
        {name:"安徽省保密局",url:"http://www.ahbm.gov.cn/"},
        {name:"黑龙江省保密局",url:"https://www.hljbm.gov.cn/"},
        {name:"山东省保密局",url:"http://bmj.shandong.gov.cn/"},
        {name:"广东省保密局",url:"http://www.bmj.gd.gov.cn/index.html"},
        {name:"吉林省保密局",url:"http://bmj.jl.gov.cn/"},
        {name:"重庆市保密局",url:"http://jbm.cq.gov.cn/"},
        {name:"上海市保密局",url:"http://www.shbmj.gov.cn/"}]
      },
      {
        id:13,
        data:{
          "channelId":"confidential",
        },
        name:"涉密案例",
        type:"ImgFloat"
      },
    ]
    },
    {
      id:2,
      title:'机构职能',
      path:'/duty',
      name:"Duty",
      alias:"duty",
      component: Duty,
      //模板2必须传导航栏
      children:[{
        id:1000,
        title: "主要职责",
        fullPath:"/duty",
        path:"",
        data:{
          "channelId":"generalOffice",
        },
        component:RightDetail,
      },{
        id:1001,
        title: "内设机构",
        path:"propagandaDepartment",
        fullPath:"/duty/propagandaDepartment",
        data:{
          "channelId":"propagandaDepartment",
        },
        component:RightDetail
      },
      {
        id:1002,
        title: "所属单位",
        path:"scienceDepartment",
        fullPath:"/duty/scienceDepartment",
        data:{
          "channelId":"scienceDepartment",
        },
        component:RightDetail
      }
    ]
    },

    {
      id:3,
      title:'党建工作',
      path:'/party',
      name:'Party',
      alias:"party",
      component: Party,
      element:[{
        id:1,
        data:{
          "channelId":"work",
          "showCount":6
        },
        carouselData:{
          "channelId":"partyWork",
          "showCount":4
        },
        title:"工作动态",
        type:"WorkTrends",
        carUrl:"",
        imgPath:require("@/assets/img/party-logo.png")
      },
      {
        id:2,
        data:{
          "channelId":"partyNews",
          "showCount":7
        },
        title:"思想理论",
        type:"PartNews"
      },
      {
        id:3,
        data:{
          "channelId":"superiorSpirit",
          "showCount":7
        },
        title:"党内法规",
        type:"PartNews"
      },
      {
        id:4,
        data:{
          "channelId":"LearningGarden",
          "showCount":7
        },
        title:"学习园地",
        type:"PartNews"
      },
      {
        id:5,
        data:{
          "channelId":"BranchDynamic",
          "showCount":7
        },
        title:"支部动态",
        type:"PartNewsLong"
      },
      {
        id:6,
        type:"ImgLink",
        img:[{path:require("@/assets/img/link/dyw.png"),url:"http://www.12371.cn/"},
        {path:require("@/assets/img/link/djw.png"),url:"http://www.dangjian.cn/"},
        {path:require("@/assets/img/link/qsw.png"),url:"http://www.qstheory.cn/"},
        {path:require("@/assets/img/link/bjw.png"),url:"http://nmgdj.gov.cn/bjsy/"}
        ]
      },
      {
        id:7,
        img:require("@/assets/img/party-title.png"),

        data:[{data:{
          "channelId":"remember",
          "showCount":7
        },
        childImg:require("@/assets/img/bwcx-banner.png")

      },{
        data:
        {
          "channelId":"Education",
          "showCount":7
        },
        childImg:require("@/assets/img/lxyz-banner.png")
      },{
        data:
        {
          "channelId":"Congress",
          "showCount":7
        },
        childImg:require("@/assets/img/sjd-banner.png")
      }],

        name:"",
        type:"PartSubject"
      },

    ]
    },
    {
      id:4,
      title:'政策法规',
      path:'/policy',
      name:'Policy',
      alias:"policy",
      component: Policy,
      children:[{
        id:1,
        title: "法律法规",
        path:"",
        fullPath:"/policy",
        data:{
          "channelId":"lawsRegulations",
          "showCount":15
        },
        component:NewsList
      },
      {
        id:2,
        title: "部门规章",
        path:"administrativeRules",
        fullPath:"/policy/administrativeRules",
        data:{
          "channelId":"administrativeRules",
          "showCount":15
        },
        component:NewsList
      },
      {
        id:3,
        title: "国家法规",
        path:"nationalLaws",
        fullPath:"/policy/nationalLaws",
        data:{
          "channelId":"nationalLaws",
          "showCount":15
        },
        component:NewsList
      }]
    },
    {
      id:5,
      sort:5,
      title:'办事大厅',
      path:'/office',
      name:'Office',
      alias:"office",
      component: Office,
      children:[{
        id:1,
        title: "涉密载体销毁",
        path:"",
        fullPath:"/office",
        data:{
          "channelId":"carrier",
          "showCount":15
        },
        component:NewsList
      },{
        id:2,
        title: "资质(格)管理",
        path:"",
        fullPath:"/office",
        component:NewsList,
        children:[
          {
            id:4,
            title: "涉密印制资质",
            path:"printQualifications",
            fullPath:"/office/printQualifications",
            data:{
              "channelId":"printQualifications",
              "showCount":15
            },
            component:NewsList,
          },
          {
            id:5,
            title: "涉密集成资质",
            path:"integrateQualifications",
            fullPath:"/office/integrateQualifications",
            data:{
              "channelId":"integrateQualifications",
              "showCount":15
            },
            component:NewsList
          },
          {
            id:6,
            title: "军工保密资质",
            path:"secrecyQualifications",
            fullPath:"/office/secrecyQualifications",
            data:{
              "channelId":"secrecyQualifications",
              "showCount":15
            },
            component:NewsList
          }
        ]
      },

      {
          id:7,
          title: "保密资料订购",
          path:"dinggou",
          fullPath:"/office/dinggou",
          data:{
            "channelId":"dinggou",
            "showCount":15
          },
          component:NewsList
        },
        {
          id:3,
          title: "定密管理及其他",
          path:"information",
          fullPath:"/office/information",
          data:{
            "channelId":"information",
            "showCount":15
          },
          component:NewsList
        }
]
    },
    {
      id:6,
      title:'宣传教育',
      path:'/propaganda',
      name:'Propaganda',
      alias:"propaganda",
      component: Media,
      children:[{
        id:1,
        title: "视频点播",
        path:"",
        fullPath:"/propaganda",
        data:{
          "channelId":"videoPlay",
          "showCount":6
        },
        component:NewsList
      },
      {
        id:2,
        title: "保密漫画",
        path:"confidentialityComic",
        fullPath:"/propaganda/confidentialityComic",
        data:{
          "channelId":"confidentialityComic",
          "showCount":15
        },
        component:NewsList
      },
      {
        id:3,
        title: "保密常识",
        path:"commonSense",
        fullPath:"/propaganda/commonSense",
        data:{
          "channelId":"commonSense",
          "showCount":15
        },
        component:NewsList
      },
      {
        id:4,
        title: "警钟长鸣",
        path:"policeRinging",
        fullPath:"/propaganda/policeRinging",
        data:{
          "channelId":"policeRinging",
          "showCount":7
        },
        component:NewsList
      }
    ]
    },
    {
      id:7,
      title:'技术防护',
      path:'/secrecy',
      name:'Secrecy',
      alias:"secrecy",
      data:{
        "channelId":"confidentialityProtection",
        "showCount":10
      },
      component:ListPage
    }
  ],

};



export default comData;
